import {convertToArray, isArrayEqual} from "../../../common/utils";
import {InputFields} from "../inputFields/userGroupInputFields";
import {getInputValuesFromGivenCondition} from "./getInputValuesFromGivenCondition";

export function isSameKeyCondition(keyCondition1, keyCondition2) {
    const keyCondition1InputValues = getInputValuesFromGivenCondition(keyCondition1);
    const keyCondition2InputValues = getInputValuesFromGivenCondition(keyCondition2);
    for (let attribute in InputFields) {
        if (!isArrayEqual(convertToArray(keyCondition1InputValues[attribute]), convertToArray(keyCondition2InputValues[attribute]))) {
            return false
        }
    }
    return true;
}
